import { OrganizationIdSchema } from '@mntn-dev/domain-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

// Prototype for an eventual integration with the route params.
// This can be a superset of route params that individual routes can pick from.
// This really helps with the AnyRoute case where the params can be a subset of these instead of unknown.

export const RouteParamsSchema = z.object({
  organizationId: OrganizationIdSchema.optional(),
})

export type RouteParams = ZodSimplify<typeof RouteParamsSchema>
